import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Collapse, Form, Input, Select, Space } from "antd";
import { EventNameSelect } from "./EventNameSelect";
import { TaskList } from "./TaskList";

interface EventsListProps {
  name: string | number | (string | number)[];
  sources?: string[];
}

export const EventsList = (props: EventsListProps) => {
  return (
    <Form.List name={props.name}>
      {(fields, { add, remove }) => (
        <div style={{ display: "flex", rowGap: 16, flexDirection: "column" }}>
          {fields.map((field) => (
            <Collapse size="small" key={field.key}>
              <Collapse.Panel
                key={field.name}
                header={`Event ${field.name + 1}`}
                extra={
                  <CloseOutlined
                    
                    onClick={() => {
                      remove(field.name);
                    }}
                  />
                }
              >
                <Space direction="vertical" size="middle">
                  <Space direction="horizontal" size="middle">
                    <Form.Item label="Source" name={[field.name, "source"]}>
                      <Select
                        style={{ width: "40%", minWidth: "250px" }}
                        options={[
                          { value: "system", label: "system" },
                          ...(props.sources?.map((source) => ({
                            value: source,
                            labels: source,
                          })) ?? []),
                        ]}
                      />
                    </Form.Item>
                    <Form.Item
                      style={{ minWidth: "250px" }}
                      label="Name"
                      name={[field.name, "name"]}
                    >
                      <EventNameSelect />
                    </Form.Item>
                  </Space>
                  <Form.Item label="Tasks">
                    <TaskList
                      targets={props.sources}
                      name={[field.name, "tasks"]}
                    />
                  </Form.Item>
                </Space>
              </Collapse.Panel>
            </Collapse>
          ))}

          <Button type="dashed" onClick={() => add()} block>
            + Add Event
          </Button>
        </div>
      )}
    </Form.List>
  );
};
